import React from 'react';
import FormItemContainerControl from './FormItemContainerControl';
import FormItemFieldGroup from '../FormItemFieldGroup';
import CmdTypeActions from '../../actions/CmdTypeActions';
import GOT from '../../utils/GOT';
import GOTUtil from '../../utils/GOTUtil';

export default class FormItemFieldGroupControl extends FormItemContainerControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemFieldGroupControl";
	}

	getProperty_FilterEditor()
	{
		let xml = this.xml;
		let componentPro = GOTUtil.getProperty(xml,"Component");
		if(componentPro && componentPro.refentityid)
			return GOTUtil.getProperty(xml,"FilterEditor");
		return {};
		//return this.properties.FilterEditor;
	}

	getProperty_Columns()
	{
		if(this.properties.hasOwnProperty("Columns"))
			return this.properties.Columns;
		if(this.properties.RowsOrColumns == 0){
			this.properties.RowsOrColumns = 1;
		}
		return this.properties.RowsOrColumns;
	}

	getProperty_ShowLabel()
	{
		return true;
		return this.properties.ShowLabel;
	}

	getProperty_HeaderAlign()
	{
		return this.properties.HeaderAlign;
	}

	getProperty_DisplayLength()
	{
		return this.properties.DisplayLength;
	}

	setControlLabelCmd(value)
	{
		this._cmdLabel = value;
		CmdTypeActions.updateControlLabel(this.xml.name,value,this.module.instanceUUId);
	}

	getProperty_AllowEdit_GOTFinal()
	{
		if(this.finalAllowEditGOT)
			return this.finalAllowEditGOT;
		
		var result = this.getProperty_AllowEdit_GOT();
		if(!result)
		{
			if(this.group)
			{
				var recVersion = this.group.getCurRecVersion();
				if(isNaN(recVersion) == false && recVersion == -1)
				{
					var componentPro = GOTUtil.getProperty(this.xml,"Component");
					if(componentPro.hasOwnProperty("refentityid"))
					{
						var allowEdits = GOTUtil.getPropertyValue(this.xml,"AllowEdit");
						if(allowEdits == "false" || !allowEdits)
						{
							var fdsfs = componentPro.V || componentPro.Value;
							var fdss = GOTUtil.getPropertyValue(this.xml,"DataSource");
							var formDataSourceField = this.group.getFormDataSourceField2(fdsfs,fdss);
							if(formDataSourceField)
							{
								allowEdits = GOTUtil.getPropertyValue(formDataSourceField,"AllowEdit");
								if(allowEdits != "" && (allowEdits == "false" || allowEdits == false))
								{
									return false;
								}
							}
							var tableId = componentPro.refentityid;
							var tableEntity = GOT.getTable(tableId);
							if(tableEntity)
							{
								var tableFieldId = componentPro.refinnerid;
								var tableField = GOT.getTableField(tableEntity,tableFieldId);
								//allowEdits = GOTUtil.getPropertyValue(tableField,"AllowEdit");
								var allowEditOnCreate = GOTUtil.getPropertyValue(tableField,"AllowEditOnCreate");
								if(allowEditOnCreate == "true" || allowEditOnCreate)
									result = true;
							}
							
						}
					}
				}
			}
		}

		if(!result)
			return false;
		
		result = this.getProperty_AllowEdit_Loop();
		this.finalAllowEditGOT = result;
		return result
		
	}
	
	getStyle()
	{
		let parentLayout = this.parentXML.Properties.Layout.Value;
		let style = {
		 	//width:'auto'
		 	
	    };

	    if(parentLayout == "horizontal")
	    {
	    	//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
	    	//alert(json);
	    	let _width = this.xml.Properties.Width.Value;
	    	if(_width == undefined)
	    		_width = "";
			let flexGrow = 0;
			let fixedWidth = false;
			let iex = _width.indexOf("%");
			if(iex!=-1)
			{
				flexGrow = _width.substring(0,iex);
			}
			
			if(iex==-1&&_width != "")
			{
				style['width'] = _width+"px";
				fixedWidth = true;
			}	
			
			if(!fixedWidth)style["flexGrow"] = flexGrow; 

			let _height = this.xml.Properties.Height.Value;
			if(_height == undefined)
				_height = "";
			if(_height == "100%")
				style["alignSelf"] = "stretch";
			else if(_height.indexOf("%") != -1)
				style["height"] = _height;
			else if(_height != "")
				style["height"] = _height+"px";
	    }
	    else //vertical 暂不考虑absolute
	    {
	    	let _height = this.xml.Properties.Height.Value;
	    	if(_height==undefined)
	    		_height = "";
			let flexGrow = 0;
			let fixedHeight = false;
			let iex = _height.indexOf("%");
			if(iex!=-1)
			{
				flexGrow = _height.substring(0,iex);
			}
			if(iex==-1&&_height != "")
			{
				//flexGrow = _height+"px";
				style['height'] = _height+"px";
				fixedHeight = true;
			}	
			
			if(!fixedHeight)style["flexGrow"] = flexGrow; 

			let _width = this.xml.Properties.Width.Value;
			if(_width == undefined)
				_width = "";
			if(_width == "100%")
				style["alignSelf"] = "stretch";
			else if(_width.indexOf("%") != -1)
				style["width"] = _width;
			else if(_width != "")
				style["width"] = _width+"px";
	    }
	    style.boxShadow = "none";
	    if(this.hasBorderSetted && this.propertyHasBorder)
		{
			style.border="solid 1px #ccc";style.margin = "1px";
		}
		else
		{
			style.border = "none";
		}
		
		return style;
	}

	getComponentInstance(parent,forLookup)
	{
		let layout = parent.Properties.Layout.Value;
		let columns = this.getProperty_Columns();
		let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();
		let showLabel=this.getProperty_ShowLabel();
		let titleAlign = this.getProperty_HeaderAlign();
		let commonProps = this.getCommonProps();
	  	this.component = <FormItemFieldGroup key={this.xml.id} xml={this.xml} parentXMLId={this.parentControl.xml.id} columns={columns} moduleInstanceId={this.module.instanceUUId}  
                parentLayout={layout} layout={this.getProperty_Layout()} forLookup={forLookup} groupAlias={this.groupAlias}
                label={label} showLabel={showLabel} customStyle={this.getStyle()} formId={this.formId} menuItemId={this.menuItemId}
                contextMenuData={this.contextMenuData} titleAlign={titleAlign} control={this} {...commonProps}/>;
		return this.component;
	}	
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemFieldGroupControl.js